import SatelliteAltIcon from "@mui/icons-material/SatelliteAlt";
import GroupsIcon from "@mui/icons-material/Groups";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import "./PartnerBand.css";

const features = [
  {
    icon: <SatelliteAltIcon />,
    name: "Science de pointe",
    desc: "Modèles climatiques et données satellites de dernière génération",
  },
  {
    icon: <GroupsIcon />,
    name: "Expertise terrain",
    desc: "Collaboration avec les acteurs de la prévention et de la lutte",
  },
  {
    icon: <LockOpenIcon />,
    name: "Service gratuit",
    desc: "Accessible à tous, citoyens comme professionnels",
  },
];

const PartnerBand = () => (
  <div className="partner-band">
    {/* Row 1 */}
    <div className="partner-band__top">
      <div className="partner-band__label">
        <span className="partner-band__label-title">
          Une coopération scientifique au service de la prévention
        </span>
        <span className="partner-band__label-sub">Développé conjointement par : </span>
      </div>
      <div className="partner-band__logos">
        <img src="/images/edhec-climate-institute.png" alt="EDHEC Climate Institute" />
        <img src="/images/climate-innov.png" alt="Climate Innov" />
      </div>
    </div>

    {/* Row 2 */}
    <div className="partner-band__features">
      {features.map((f) => (
        <div className="partner-band__feature" key={f.name}>
          <span className="partner-band__feature-icon">{f.icon}</span>
          <span className="partner-band__feature-text">
            <span className="partner-band__feature-name">{f.name}</span>
            <span className="partner-band__feature-desc">{f.desc}</span>
          </span>
        </div>
      ))}
    </div>
  </div>
);

export default PartnerBand;
